import { apiFetch, API_BASE_URL } from "./api";

/** Uploads a photo for a site's pages and returns the URL to use as an image src. */
export async function uploadSiteImage(siteId: string, file: File): Promise<string> {
  const form = new FormData();
  form.append("file", file);
  const result = await apiFetch<{ url: string }>(`/sites/${siteId}/media`, {
    method: "POST",
    body: form,
  });
  return mediaURL(result.url);
}

/** Relative media paths belong to the API when dashboard and API use separate hosts. */
export function mediaURL(value: string): string {
  if (value.startsWith("/api/v1/media/") && /^https?:\/\//.test(API_BASE_URL)) {
    return new URL(value, API_BASE_URL).href;
  }
  return value;
}
